import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {RequestService} from "../../services/request/request.service";
import {Subscription} from "rxjs";
import {DataManager, Query, Predicate} from "@syncfusion/ej2-data";
import {FieldSettingsModel} from "@syncfusion/ej2-lists/src/list-view/list-view-model";
import {ListViewComponent} from "@syncfusion/ej2-angular-lists";

/**
 * TODO: this is a work in progress. It is designed ot be placed as an angular component on the
 * ImportTransform form with the following renderer properties:
 *
 * component: sb-ng-knockout-form-wrapper
 * input.component: sb-ng-import-transform-diagram
 * input.title: Transform diagram
 */
@Component({
  selector: 'sb-import-transform-diagram',
  templateUrl: './import-transform-diagram.component.html',
  styleUrls: ['./import-transform-diagram.component.scss'],
})
export class ImportTransformDiagramComponent implements OnInit {

  message = "";

  mappingsJson: any = "";
  transformJson: any = "";
  dataJson: any = "";

  private mappings: any[] = [];
  private transform: any = "";

  mappingsData = [];

  private subscription: Subscription;

  bgSourceName: string = "";
  bgTargetName: string = "";

  public bgListFields: FieldSettingsModel = { text: "text", id: "id" };

  @ViewChild('bgSearch')
  bgSearch: any;

  @ViewChild('bgListView')
  bgListView: ListViewComponent;

  // -----------------------------------------------------------------------


  // Marked as @Input() so that it is visible on the knockout side as part of the web component.
  @Input()
  update: any;

  constructor(private requestService: RequestService) {
    this.update = async (current: any, target: any, fieldName?: any) => {

      if (!this.subscription) {
        this.subscription = (window as any).MessageBus.subscribe(
          (window as any).MessageBus.CHANNELS.FORM_API_EVENT,
          `onRelationUpdate:${target.getEventExecutor()._formInstanceUuid}`,
          async (data: any, envelope: any) => {
            await this.updateImpl(data.current, null, null);
          });
      }

      await this.updateImpl(current, target, fieldName);
    };

  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }

  @Input()
  async updateImpl(current: any, target: any, fieldName?: any) {

    if (!current._data) {
      return;
    }

    this.message = '';
    const id = current._data._mappedData.id();
    const req = this.requestService.createRequest();
    const query = this.requestService.createControllerQuery();
    query.query({fieldName: "Parent", operator: "=", value: id});
    query.maxResults(1000); // TODO - what should this be?

    const response: any = await req
      .controller("servicely.core.System")
      .table("ImportTransformMapping")
      .method("list")
      .controllerQuery(query)
      .execute();

    this.mappings = response.data;
    this.transform = current;

    this.mappingsJson = JSON.stringify(this.mappings, null, 2);
    this.transformJson = JSON.stringify(this.transform, null, 2);

    const data = {
      id: this.transform._data._mappedData.id(),
      name: this.transform.Name(),
      description: this.transform.Description(),
      sourceID: this.transform.Source(),
      targetTable: this.transform.Target(),
      resetProcessedRecords: this.transform.ResetProcessedRecords(),
      nextTransformID: this.transform.NextTransform(),
      mappings: this.mappings.map((m) => {
          return {
            id: m.id,
            name: m.Name.value,
            type: m.Type.value,
            sourceField: m.SourceField.value,
            targetField: m.TargetField.value,
            primaryKey: m.PrimaryKey.value,
            lookupTable: m.LookupTable.value,
            lookupField: m.LookupField.value,
          };
      })
    };

    this.dataJson = JSON.stringify(data, null, 2);

    if (data.sourceID) {
      const response: any = await this.requestService.createRequest()
        .controller("servicely.core.System")
        .table("ImportTable")
        .method("get")
        .data({id: data.sourceID})
        .execute();

      const name = response.data.Name.value;

      this.bgSourceName = name;
    }

    if (data.targetTable) {
      this.bgTargetName = data.targetTable;
    }

    this.mappingsData = this.mappings.map((m) => {
      return {
        text: m.Name.value,
        SourceField: m.SourceField.value,
        TargetField: m.TargetField.value,
        LookupTable: m.LookupTable.value,
        LookupField: m.LookupField.value,
        id: m.id,
        data: m,
        avatar: m.Type.displayValue.substring(0, 1)
      } ;
    });
  }

  deleteItem(e: MouseEvent) {
  }

  addItem(e: MouseEvent) {
  }

  onkeyup(e: KeyboardEvent) {
    let value = this.bgSearch.nativeElement.value;
    const predicate1: Predicate = new Predicate('text', 'contains', value, true, true);
    const predicate2: Predicate = new Predicate('SourceField', 'contains', value, true, true);
    const predicate3: Predicate = new Predicate('TargetField', 'contains', value, true, true);
    const predicate4: Predicate = new Predicate('LookupTable', 'contains', value, true, true);
    const predicate5: Predicate = new Predicate('LookupField', 'contains', value, true, true);
    const predicate = !value ? new Predicate('id', 'notequal', '') : predicate1.or(predicate2).or(predicate3).or(predicate4).or(predicate5);
    let data = new DataManager(this.mappingsData).executeLocal(new Query().where(predicate));
    this.bgListView.dataSource = data as any[];

    this.bgListView.dataBind();
  }

}
